import { fetchApi, trackError } from '@vend/utilities'
import { ApiSale } from '@vend/types'
import { SaleStatus } from '../../../../models/sale.constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'

const MAX_SALES = 10

const readApiSearchEndpoint = '/api/2.0/sales'
const typeySearchEndpoint = '/api/2.0/search'

export interface GetParkedSaleResult {
  sales: ApiSale[]
  hasMore: boolean
}

export const getParkedSales = (
  activeOutletId: string
): Promise<GetParkedSaleResult> => {
  const useReadApi = getFeatureFromCache('parked_sales_from_read_api')

  const searchEndpoint = useReadApi
    ? readApiSearchEndpoint
    : typeySearchEndpoint

  const params = new URLSearchParams({
    outlet_id: activeOutletId,
    page_size: (MAX_SALES + 1).toString(),
  })

  if (useReadApi) {
    params.set('status', SaleStatus.PARKED.toLowerCase())
    params.set('desc', '1')
  } else {
    params.set('status[]', SaleStatus.PARKED.toLowerCase())
    params.set('order_by', 'date')
    params.set('order_direction', 'desc')
    params.set('type', 'sales')
  }

  const url = new URL(searchEndpoint, window.location.origin)
  url.search = params.toString()

  return fetchApi(url.toString())
    .then(response => response.json())
    .then(result => {
      const sales: ApiSale[] = result.data || []
      const hasMore = sales.length > MAX_SALES
      if (hasMore) {
        sales.length = MAX_SALES
      }
      return { sales, hasMore }
    })
    .catch(err => {
      trackError(err)
      return { sales: [], hasMore: false }
    })
}
